import { AwsUi } from '../../../../core/runtime/src';
import { ComponentFeature } from '../internal';
import { getCollectionComponent, arrayItemsEqual, ChangeHandler } from '../utility';
import selectionUtility from './utils';
var __updateController = function (oldValue, newValue) {
    if (oldValue !== newValue && this.__controller && !this.__inhibitControllerUpdate) {
        this.__controller.processComponentChange(ComponentFeature.SELECTION, this.__getData(), false);
    }
};
var __handleChange = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    this.__changeHandler.apply(this, args);
};
var _a = AwsUi.__addComponents(['awsui-table-selection', 'awsui-cards-selection'], {
    releaseStatus: 'stable',
    events: {
        // Fired when a user interaction triggers a change in the list of selected items.
        // The event `detail` will contain the current list of `selectedItems`.
        //
        // A selection change can also be triggered by filtering, pagination or sorting changes
        // because all selected items that are no longer visible will be automatically de-selected
        // unless you set `keepSelection` property to true - see its documentation for more details).
        selectionChange: {
            bubbles: true,
            cancelable: false,
            detailType: {
                type: 'object',
                objectType: 'TableSelection.SelectionChangeDetail',
                itemType: 'Item'
            }
        }
    },
    generics: {
        Item: {
            defaultType: 'Table.Item'
        }
    },
    properties: {
        // Type of the selection. It can be either 'single' or 'multi'.
        selectionType: {
            type: 'string',
            defaultValue: 'multi',
            optional: true,
            valid: ['single', 'multi'],
            onChange: __handleChange
        },
        // List of selected items.
        selectedItems: {
            type: 'array',
            itemTypes: ['Item'],
            optional: true,
            onChange: __handleChange
        },
        // Function to choose which items are disabled. Once an item is disabled,
        // the user can't select it.
        isItemDisabled: {
            type: 'function',
            functionType: 'TableSelection.disablingFunction',
            functionGenericType: 'Item',
            defaultValue: selectionUtility.defaultDisableFunction,
            onChange: __handleChange
        },
        // Property inside items that uniquely identifies them.
        // It can be needed for performance reasons: it allows to recognize
        // that a certain item is still selected even if the reference of the object changes, but the
        // property specified here is the same.
        trackBy: {
            type: 'string',
            optional: true,
            onChange: __handleChange
        },
        // If set to `true`, selected items will be kept across pagination, sorting, filtering
        // and page size changes.
        keepSelection: {
            type: 'boolean',
            onChange: __handleChange
        },
        // Adds labels to the selection components (checkboxes and radio buttons):
        // * on individual items: `itemSelectionLabel` [`(SelectionState, Item) => string`]
        // * column header (Table only): `allItemsSelectionLabel` [`(SelectionState) => string`]
        // * group label: `selectionGroupLabel` [`string`]
        //
        // The first arguments of type `SelectionState` can be used to access the current selection
        // state of the component, e.g., the `selectedItems` list. The label function for individual
        // items will also receive the corresponding  `Item` object. The group label can be used to
        // add a meaningful description to the whole selection.
        labels: {
            type: 'object',
            objectType: 'TableSelection.SelectionLabels',
            itemType: 'Item',
            onChange: function () {
                if (this.__controller) {
                    this.__controller.updateSelectionLabels();
                }
            }
        }
    },
    callbacks: {
        initialized: function () {
            this.__changeHandler = new ChangeHandler(__updateController);
        },
        attached: function () {
            this.__parentComponent = getCollectionComponent(this.node);
            this.__parentComponent.__selection = this;
            this.__controller = this.__parentComponent.__controller;
        },
        detached: function () {
            if (this.__parentComponent) {
                this.__parentComponent.__selection = null;
                this.__controller = null;
            }
        }
    },
    functions: {
        __getData: function () {
            return {
                selectedItems: this.selectedItems,
                selectionType: this.selectionType,
                trackBy: this.trackBy,
                keepSelection: this.keepSelection,
                isItemDisabled: this.isItemDisabled
            };
        },
        __getEventData: function () {
            return {
                selectedItems: this.selectedItems
            };
        },
        __updateData: function (selectionData, fireEvent) {
            var _this = this;
            this.__changeHandler.prevent(function () {
                if (!arrayItemsEqual(_this.selectedItems, selectionData.selectedItems)) {
                    // avoid useless re-rendering
                    _this.selectedItems = selectionData.selectedItems;
                }
                _this.isItemDisabled = selectionData.isItemDisabled;
                _this.selectionType = selectionData.selectionType;
            });
            if (fireEvent) {
                this.__fireEvent('selectionChange', this.__getEventData());
            }
        },
        __getSelectionLabels: function () {
            var defaultLabel = function () { return ''; };
            var labels = this.labels || {};
            return {
                itemSelectionLabel: labels.itemSelectionLabel || defaultLabel,
                allItemsSelectionLabel: labels.allItemsSelectionLabel || defaultLabel,
                selectionGroupLabel: labels.selectionGroupLabel || ''
            };
        },
        __getSelectionState: function () {
            return {
                selectedItems: this.selectedItems
            };
        }
    },
    render: function (m, h) {
        return '';
    }
}), TableSelection = _a[0], CardsSelection = _a[1];
export { TableSelection, CardsSelection };
//# sourceMappingURL=index.js.map